import { Container } from 'react-bootstrap';
import styled from 'styled-components';

export const CommonContainer = styled(Container)`
      margin-top: 3rem;
      margin-bottom: 3rem;
`;
